import { BoxGeometry, CylinderGeometry, Group, Mesh, MeshStandardMaterial, PlaneGeometry } from 'three';
import { BILLBOARDS } from '../../content/ads';
import { Rng } from '../../core/rng';
import { flatMaterial } from '../../render/materials/cache';
import { canvasTexture } from '../../render/materials/canvasTexture';

let materials: MeshStandardMaterial[] | null = null;

function adMaterials(): MeshStandardMaterial[] {
  materials ??= BILLBOARDS.map((ad) =>
    new MeshStandardMaterial({
      map: canvasTexture(512, 256, (ctx) => {
        ctx.fillStyle = ad.bg;
        ctx.fillRect(0, 0, 512, 256);
        ctx.fillStyle = ad.accent;
        ctx.fillRect(0, 196, 512, 60);
        ctx.fillStyle = ad.fg;
        ctx.font = 'bold 64px Impact, "Arial Black", sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(ad.title, 256, 110, 480);
        ctx.font = 'bold 28px Arial, sans-serif';
        ctx.fillStyle = ad.bg === '#ffcc00' ? '#ffffff' : ad.fg;
        ctx.fillText(ad.line, 256, 236, 480);
      }),
    }),
  );
  return materials;
}

/** One optional roadside billboard per tile. */
export class Billboard {
  readonly group = new Group();
  private readonly board: Mesh;

  constructor() {
    const pole = new Mesh(new CylinderGeometry(0.2, 0.25, 7, 8), flatMaterial('#6c757d'));
    pole.position.y = 3.5;
    const frame = new Mesh(new BoxGeometry(7.4, 3.6, 0.3), flatMaterial('#3a3a3a'));
    frame.position.set(0, 8, -0.2);
    this.board = new Mesh(new PlaneGeometry(7, 3.3), adMaterials()[0]);
    this.board.position.set(0, 8, -0.04);
    frame.castShadow = true;
    this.group.add(pole, frame, this.board);
  }

  dress(tileIndex: number, x: number, visible: boolean): void {
    const rng = new Rng(tileIndex * 13 + 5);
    this.group.visible = visible;
    if (!visible) return;
    this.board.material = rng.pick(adMaterials());
    this.group.position.set(x, 0, -rng.range(8, 32));
    // Face oncoming drivers, angled towards the road.
    this.group.rotation.y = x > 0 ? 0.45 : -0.45;
  }
}
